import React, { useState, useRef, useEffect } from "react";

import { useNavigate, useLocation } from "react-router-dom";

import { Link } from "react-router-dom";

// @mui/material components

import CircularProgress from '@mui/material/CircularProgress';
import Divider from "@mui/material/Divider";
import Dialog from '@mui/material/Dialog';
import LinearProgress from '@mui/material/LinearProgress';

import avatarjuego from "../assets/images/avatarjuego.png";
import avatarjuego2 from "../assets/images/avatarjuego2.jpg";

// core components
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import { Avatar } from '@mui/material';
import Map from "@mui/icons-material/Map";
import { IconButton, Tooltip, Stack, Paper } from "@mui/material";

import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import AutoStories from "@mui/icons-material/AutoStories";
import QuestionAnswer from "@mui/icons-material/QuestionAnswer";
import TipsAndUpdates from "@mui/icons-material/TipsAndUpdates";
import HomeIcon from "@mui/icons-material/Home";
import TipsAndUpdatesIcon from "@mui/icons-material/TipsAndUpdates";
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'; // �cono sugerido
import CloseIcon from '@mui/icons-material/Close'; // �cono sugerido
import Star from '@mui/icons-material/Star';

import OthelloPopUpResult from "../componentsothello/OthelloPopUpResult.jsx";
import OthelloModalBase from "../componentsothello/OthelloModalBase.jsx";

import { DialogOthelloResult, Visibilidad, TipoValidacionEncuenta, DataStateModal, ModoModal } from "../othelloConstantes.jsx";
import { GetGoogleMaps } from "../othelloFunciones.jsx";

import OthelloEdit  from "../componentsothello/OthelloEdit.jsx";

import { Helmet } from 'react-helmet'
import OthelloPrimary from "../componentsothello/OthelloPrimary.jsx";
import MDBox from "../components/MDBox/index.js";
import MDTypography from "../components/MDTypography/index.js";
import MDButton from "../components/MDButton/index.js";
import MDInput from "../components/MDInput/index.js";
import MDAvatar from "../components/MDAvatar/index.js";

import { useTranslation } from 'react-i18next';

import confetti from 'canvas-confetti';
import Slide from 'react-reveal/Slide';
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import Pulse from "react-reveal/Pulse";

import TypingEffect from 'react-typing-effect';

import chroma from 'chroma-js';


export default function FormularioJuego({ ...props }) {
    const { literal, idRol, tipooficina, loginmodoreserva, loginapps, idUser } = props;

    //ejemplo url
    //https://gestor.ovtspain.es/formulario/encuesta?id={Id_Oficina}-{tokenid}&data={dataencodedbase64}"

    const navigate = useNavigate();

    const { search } = useLocation();

    const { t } = useTranslation();

    const [loading, setLoading] = React.useState(true);
    
    const [idofi, setidofi] = React.useState(-1);
    const [idenc, setidenc] = React.useState(-1);    
    const [data, setdata] = React.useState(null);
    const [encuesta, setencuesta] = React.useState(null);

    const [mapaopen, setmapaopen] = React.useState(false);
    const [pistasopen, setpistasopen] = React.useState(false);
    const [pistashowed, setpistashowed] = React.useState(-1);
    
    const [currentstep, setcurrentstep] = React.useState(-1);
    const [currentPasoPregunta, setcurrentPasoPregunta] = React.useState(0);

    const [stateModalReiniciar, setstateModalReiniciar] = React.useState(false);
    const [stateModalIncorrecta, setstateModalIncorrecta] = React.useState(DataStateModal.dsClosed);
    
    const [guardandoencuesta, setguardandoencuesta] = React.useState(false);
    
    const [validado, setvalidado] = React.useState(false);
    const [stateModal, setstateModal] = React.useState(DataStateModal.dsClosed);
    const [modomodal, setmodomodal] = React.useState(null);

    const [codigo, setcodigo] = React.useState("");
    const [dataeditando, setdataeditando] = React.useState(null);

    const [alert, setalert] = React.useState(null);
    const [alertaopcion, setalertaopcion] = React.useState(null);

    const [descripcionMostrada, setDescripcionMostrada] = useState(false);

    const [puntos, setpuntos] = React.useState(0);
    const [textoasistente, settextoasistente] = React.useState(0);

    const [esperandoProximaPregunta, setEsperandoProximaPregunta] = useState(false);

    const [backcolor, setbackcolor] = React.useState("");
    const [backcolorhover, setbackcolorhover] = React.useState("");    

    const musicaRef = useRef(null);
    const aplausosRef = useRef(null);

    const NumPasoInicio = 4;

    const TipoError = {
        Preguntas: 0,
        JuegoNoDisponible: 1,
        ErrorCargaJuego: 2
    }

    const TipoPantalla = {
        Informacion: 0,
        Preguntas: 1,        
        FinJuego: 2,
        EncuestaFinalizada: 3
    }

    const PasosPregunta = {
        InfoPregunta: 0,
        RealizaPregunta : 1,
        ResultadoPregunta : 2
    }

    const TextoAsistente = {
        Bienvenido: 0,
        RespuestaIncorrecta: 1,
        RespuestaCorrecta: 2,
        UsoPistas: 3,
        CerrandoPistas : 4,
        NuevaPregunta: 5
    }

    React.useEffect(() => {
        // Establecer estilos espec�ficos para el body y root
        document.body.style.margin = '0';
        document.body.style.padding = '0';
        document.body.style.overflow = 'hidden';
        document.body.style.overscrollBehavior = 'none';
        document.body.style.height = '100vh'; // Probamos con 100vh
        document.body.style.width = '100vw';
        document.body.style.position = 'fixed';
        document.body.style.top = '0';
        document.body.style.left = '0';

        const rootElement = document.getElementById('root');
        if (rootElement) {
            rootElement.style.height = '100vh'; // Probamos con 100vh
            rootElement.style.width = '100vw';
            rootElement.style.overflow = 'hidden';
            rootElement.style.position = 'fixed';
            rootElement.style.top = '0';
            rootElement.style.left = '0';
        }

        // Limpiar los estilos al desmontar (opcional)
        return () => {
            document.body.removeAttribute('style');
            const rootElement = document.getElementById('root');
            if (rootElement) {
                rootElement.removeAttribute('style');
            }
        };
    }, []);

    React.useEffect(() =>
    {
        let url = search;
        let params = new URLSearchParams(url);

        let identificador = params.get('id');
        let dt = params.get('data');        

        let idsplit = identificador.split('-');

        setidofi(idsplit[0]);
        setidenc(idsplit[1]);                
        setdata(dt);
        
        getDataPage(idsplit[0], idsplit[1], dt);
    }, [loading]);

    React.useEffect(() => {

        let TipoScreenShow = getTipoPantallaToShow();

        if (currentstep == 0)
            iniciarMusicaFondo();
        else if (TipoScreenShow == TipoPantalla.FinJuego)
        {
            lanzarConfeti(true);
            reproducirAplausos();
            //aplausos.play();
        }       
        else if (TipoScreenShow == TipoPantalla.EncuestaFinalizada) {            
            SendEncuesta();
        }

    }, [currentstep]);

    React.useEffect(() => {

        let PasoNow = getPasoEnPregunta();        

        if (PasoNow == PasosPregunta.ResultadoPregunta)
            lanzarPapeles();
            
    }, [currentPasoPregunta]);
   
    useEffect(() => {
        musicaRef.current = new Audio("musicajuego.mp3");
        musicaRef.current.loop = true;

        aplausosRef.current = new Audio("ovacion.mp3");

        return () => {
            // Limpieza opcional
            musicaRef.current?.pause();
            aplausosRef.current?.pause();
        };
    }, []);


 
    const getDataPage = (idofi, idenc, data) => {
        if (idofi != null && data != null && idenc != null) {
            var jsonData = JSON.stringify({ idofi: idofi, idenc: idenc, data: data, preselected: "" });

            fetch('api/Data/GetEncuestaFormulario', {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: jsonData

            }).then(response => response.json()).then(res => {

                if (res != null)
                {
                    if (res.backColor != null && res.backColor != "") {
                        setbackcolor(res.backColor);
                        setbackcolorhover(chroma(backcolor).brighten(0.4).hex());                        
                    }
                    setencuesta(res);
                    setLoading(false);                   
                }
                else {
                    setencuesta({ id_Encuesta: -1 });
                    setLoading(false);
                }
            }).catch(error => {
                setencuesta({ id_Encuesta: -1 });
                setLoading(false);
            });
        }
    }

    const getImageAvatar = () => {

        if (encuesta.imageAvatar != null && encuesta.imageAvatar != "")
            return encuesta.imageAvatar;
        else
            return avatarjuego2;
    }

    const onClosePopUpResult = () => {
        setalert(null);
        setalertaopcion(null);
    }

    const othelloModalResul = (modo, result, valor) =>
    {
        if (result == DialogOthelloResult.OK) {
            var object = "";
            let formulariovalida = document.getElementById('formvalidacion');
            let formvalida = new FormData(formulariovalida);
            formvalida.forEach((value, key) => { object += value + "|" });

            codigo = object;

            if (object != "")
                SendEncuesta();
            else {
                setstateModal(DataStateModal.dsClosed);
                setmodomodal("");
            }
        }
        else {
            setstateModal(DataStateModal.dsClosed);
            setmodomodal("");
        }            
    }

    const iniciarMusicaFondo = () => {
        const musica = musicaRef.current;
        if (musica && musica.paused) {
            musica.play().catch((e) => {
                console.error("Error al iniciar m�sica:", e);
            });
        }
    };
  
    const reproducirAplausos = () => {
        const musica = musicaRef.current;
        const aplausos = aplausosRef.current;

        if (!musica || !aplausos) return;

        musica.pause();

        // Reiniciamos aplausos desde el principio
        aplausos.currentTime = 0;
        aplausos.play().then(() => {
            aplausos.onended = () => {
                musica.play();
            };
        }).catch((e) => {
            console.error("Error al reproducir aplausos:", e);
        });
    };
 
    const NextStep = (e) =>
    {       
        let paso = currentstep + 1;        
        setcurrentstep(paso);        
    }

    const NextStepEnPregunta = (e) =>
    {
        //Obtengo en el paso 
        let PasoNow = getPasoEnPregunta();

        //Si esto mostrando la info de la pregunta, me voy a realizar preguntar
        if (PasoNow == PasosPregunta.InfoPregunta)
            setcurrentPasoPregunta(PasosPregunta.RealizaPregunta);
        //Si estamos realizando la pregunta voy a ver el resultado
        else if (PasoNow == PasosPregunta.RealizaPregunta)
            setcurrentPasoPregunta(PasosPregunta.ResultadoPregunta)
        //Si esto es el resultado, voy a la siguiente pregunta, por tanto, tengo pasar de pregunta y ponerlo en la info de la pregunta
        else if (PasoNow == PasosPregunta.ResultadoPregunta)
        {
            setcurrentPasoPregunta(PasosPregunta.InfoPregunta)

            //AL llegar aqui, el paso del asitente sera el de nuevapregunta
            settextoasistente(TextoAsistente.NuevaPregunta);

            NextStep(null);
        }        
    }

    const getTipoPantallaToShow = () => {

        if (currentstep < NumPasoInicio)
            return TipoPantalla.Informacion
        else {

            let IndexPreguntaActual = getCurrentIndexPregunta();

            if (encuesta.preguntas != null && encuesta.preguntas.length > 0 && encuesta.preguntas.length == IndexPreguntaActual)
                return TipoPantalla.FinJuego;
            else if (encuesta.preguntas != null && encuesta.preguntas.length > 0 && encuesta.preguntas.length < IndexPreguntaActual)
                return TipoPantalla.EncuestaFinalizada;
            else
                return TipoPantalla.Preguntas;
        }
    }
  
    const getCurrentIndexPregunta = () => {

        let currentstepFinal = currentstep - NumPasoInicio;
        return currentstepFinal;
    }

    const getPreguntaActual = () => {

        if (encuesta.preguntas != null && encuesta.preguntas.length > 0)
        {
            let IndexPreguntaActual = getCurrentIndexPregunta();

            let pasoActual = null;

            if (encuesta.preguntas != null && encuesta.preguntas.length > 0 && encuesta.preguntas.length > IndexPreguntaActual)
                pasoActual = encuesta.preguntas[IndexPreguntaActual];

            if (pasoActual != null)
                return pasoActual;
            else
                return null;
        }
        else
            return null;
    }

    const getPasoEnPregunta = () => {
        return currentPasoPregunta;
    }

    const ResponderPregunta = (e) => {

        if (encuesta != null && encuesta.id_Encuesta > 0) {
            if (encuesta.visible == Visibilidad.Si) {
                if (encuesta.preguntas != null && encuesta.preguntas.length > 0) {
                    let PreguntaActual = getPreguntaActual();

                    if (PreguntaActual != null) {

                        let respuesta = document.getElementById('respuesta');

                        if (respuesta != null && respuesta.value != null && respuesta.value.trim() !== "") {

                            // Mapeo de respuestas escritas en palabras a n�meros
                            const mapaNumeros = {
                                "cero": "0",
                                "uno": "1",
                                "una": "1",
                                "dos": "2",
                                "tres": "3",
                                "cuatro": "4",
                                "cinco": "5",
                                "seis": "6",
                                "siete": "7",
                                "ocho": "8",
                                "nueve": "9",
                                "diez": "10",
                                "once": "11",
                                "doce": "12",
                                "trece": "13",
                                "catorce": "14",
                                "quince": "15",
                                "dieciseis": "16",
                                "diecis�is": "16",
                                "diecisiete": "17",
                                "dieciocho": "18",
                                "diecinueve": "19",
                                "veinte": "20",
                                "treinta": "30",
                                "cuarenta": "40",
                                "cincuenta": "50",
                                "sesenta": "60",
                                "setenta": "70",
                                "ochenta": "80",
                                "noventa": "90",
                                "cien": "100"
                            };

                            // Funci�n para normalizar texto (sin tildes, en min�sculas y con equivalencia num�rica)
                            const normalizar = (texto) => {
                                const limpio = texto
                                    .toLowerCase()
                                    .normalize("NFD")
                                    .replace(/[\u0300-\u036f]/g, "") // sin acentos
                                    .trim();

                                // Si es un n�mero, lo devolvemos tal cual
                                if (!isNaN(limpio)) return limpio;

                                // Si est� en el mapa, devolvemos el n�mero correspondiente
                                return mapaNumeros[limpio] || limpio;
                            }

                            const respuestaUsuario = normalizar(respuesta.value);
                            const respuestaCorrecta = normalizar(PreguntaActual.defaultValue);

                            if (respuestaUsuario === respuestaCorrecta) {
                                setEsperandoProximaPregunta(true);
                                setmapaopen(false);
                                setpistasopen(false);
                                setpistashowed(-1);
                                setDescripcionMostrada(false);
                                settextoasistente(TextoAsistente.RespuestaCorrecta);
                                ActualizacionPuntos(PreguntaActual);
                                lanzarConfeti();
                                reproducirAplausos();

                                setTimeout(() => {
                                    setEsperandoProximaPregunta(false);
                                    NextStepEnPregunta();
                                }, 5000);
                            } else {
                                setstateModalIncorrecta(true);
                                settextoasistente(TextoAsistente.RespuestaIncorrecta);
                            }
                        }

                    }
                }
            }
        }
    }

    const ActualizacionPuntos = (pistaActual) => {

        let currentPuntos = puntos;

        if (pistaActual.opciones != null && pistaActual.opciones.split("|").length > 0) {

            //Si no se mostro ninguna pista
            if (pistashowed < 0)
                currentPuntos += 10;
            else {
                //numero de pista son todas menos la ultima, ya que esa te da el resultado
                let numpistas = pistaActual.opciones.split("|").length;

                let puntopospista = 10 / numpistas;

                let puntosfinal = 10 - (puntopospista * (pistashowed+1));

                currentPuntos += Math.ceil(puntosfinal);
            }
        }
        //sino hubo ayudas 10 puntos
        else
            currentPuntos += 10;

        setpuntos(currentPuntos);
    }

    const getDataAsistenteVirtual = (pistaActual) =>
    {        
        if (textoasistente == TextoAsistente.Bienvenido)
            return t("_wellcomeasis")
        else if (textoasistente == TextoAsistente.RespuestaIncorrecta)
            return t("_questionerror")
        else if (textoasistente == TextoAsistente.RespuestaCorrecta)
        {
            let IndexPreguntaActual = getCurrentIndexPregunta();
            let IndexFInal = encuesta.preguntas.length - 1;

            if (encuesta.preguntas != null && encuesta.preguntas.length > 0 && IndexFInal == IndexPreguntaActual )
                return t("_questionfinal");
            else
                return t("_questionok")
        }
        else if (textoasistente == TextoAsistente.UsoPistas)
        {
            if (pistaActual.opciones != null && pistaActual.opciones.split("|").length > 0) {

                if (pistashowed == -1)
                    return t("_usopistas");
                else {
                    //Si no estamos en la ultima pista
                    if (pistashowed < pistaActual.opciones.split("|").length - 1) {
                        const numero = Math.floor(Math.random() * 3) + 1;

                        if (numero == 1)
                            return t("_infopista1");
                        else if (numero == 2)
                            return t("_infopista2");
                        else if (numero == 3)
                            return t("_infopista3");
                    }
                    else
                        return t("_infopista4");
                }
            }
            else
                return t("_sinpistas")
        }
        else if (textoasistente == TextoAsistente.CerrandoPistas)
            return t("_cerrandopistas")
        else if (textoasistente == TextoAsistente.NuevaPregunta)
        {
            const numero = Math.floor(Math.random() * 3) + 1;
            
            if (numero == 1)
                return t("_infopuntos")
            else if (numero == 2)
                return t("_infomoticacion1")
            else if (numero == 3)
                return t("_infomoticacion2")
        }
        else
            return "....."
    }

    const ReiniciarJuego = (e, modofinal) =>
    {
        if (modofinal)
            window.location.reload();
        else
            setstateModalReiniciar(true);
    }

    const BotonMapa = (e) => {

        setmapaopen(!mapaopen);
    }
    
    const BotonPistas = (e) => {

        if (!descripcionMostrada)
            setDescripcionMostrada(true)

        //Si el boton de pista abre, entonces el texto que mostrara el asistente es el de informacion de las pista
        if (!pistasopen)
            settextoasistente(TextoAsistente.UsoPistas);
        //es que vamos a cerrar asi que le digo que ya lo tienes
        else
            settextoasistente(TextoAsistente.CerrandoPistas);

        if (pistashowed < 0)
            setpistashowed(0);

        setpistasopen(!pistasopen);
    }

    const NextPistas = () => {
        settextoasistente(TextoAsistente.UsoPistas);
        setpistashowed(pistashowed +1);
    }

    const handleSpeak = (e, text) => {
        e?.stopPropagation?.();


        if ('speechSynthesis' in window && text) {
            const musica = musicaRef.current;
            if (!musica) return;

            // Pausar m�sica
            musica.pause();

            // Preparar utterance
            const utterance = new SpeechSynthesisUtterance(text);

            // Reanudar m�sica cuando termine de hablar
            utterance.onend = () => {
                musica.play();
            };

            // Tambi�n en caso de error
            utterance.onerror = () => {
                musica.play();
            };

            // Cancelar cualquier otro habla pendiente
            speechSynthesis.cancel();
            speechSynthesis.speak(utterance);
        } else {
            alert('Tu navegador no soporta Text-to-Speech.');
        }
    }


        /*if ('speechSynthesis' in window)
        {
            const musica = musicaRef.current;
            
            if (!musica) return;

            musica.pause();

            // Reiniciamos aplausos desde el principio
            aplausos.currentTime = 0;
            aplausos.play().then(() => {
                aplausos.onended = () => {
                    musica.play();
                };
            }).catch((e) => {
                console.error("Error al reproducir aplausos:", e);
            });

            const utterance = new SpeechSynthesisUtterance(text);
            speechSynthesis.speak(utterance);
        } else {
            alert('Tu navegador no soporta Text-to-Speech.');
        }*/
   

    const SendEncuesta = () => {

        lanzarConfeti(true);
        reproducirAplausos();
        //aplausos.play();

        if (true) {


        }
       /* let res = "";
        let formulario = document.getElementById('formencuesta');
        let formdata = new FormData(formulario);
        let tipovalidacion = -1;

        var object = {};
        formdata.forEach((value, key) => {

            res += key + '=' + value + '|';

            if (key == "tipovalidacion")
                tipovalidacion = value;

            object[key] = value;
        });

        //Guardo los datos introducidos por el usuario
        setdataeditando({ ...object });

        if (res != null && res != "") {
            if (stateModal == DataStateModal.dsClosed && encuesta.tipoValidacion != TipoValidacionEncuenta.SinValidacion) {
                setstateModal(DataStateModal.dsOpen);
                setmodomodal("login");
            }
            else {
                var jsonData = JSON.stringify({ idofi: encuesta.id_Oficina, idenc: encuesta.id_Encuesta, codigo: codigo, data: res, tipovalidacion: tipovalidacion });

                setguardandoencuesta(true);

                fetch('api/Data/GuardarEncuesta', {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: jsonData

                }).then(response => response.json()).then(res => {
                    if (res != null) {
                        //Si hubo error
                        if (res.grabada) {
                            setalert(PopUpResult.OK);
                            setguardandoencuesta(false);
                            setencuestafinalizada(true);
                            setstateModal(DataStateModal.dsClosed);
                            setmodomodal(null);
                        }
                        else {
                            setalert(PopUpResult.KO);
                            setguardandoencuesta(false);
                            setalertaopcion(res.error);
                            setstateModal(DataStateModal.dsClosed);
                            setmodomodal(null);
                        }
                    }
                    else {
                        setalert(PopUpResult.KO);
                        setguardandoencuesta(false);
                        setalertaopcion("Error interno al grabar la encuesta");
                        setstateModal(DataStateModal.dsClosed);
                        setmodomodal(null);
                    }
                    
                }).catch(error => {
                    setalert(PopUpResult.KO);
                    setguardandoencuesta(false);
                    setalertaopcion("Error interno al grabar la encuesta");
                    setstateModal(DataStateModal.dsClosed);
                    setmodomodal(null);
                });
            }
        }
        else {
            setalert(PopUpResult.KO);
            setguardandoencuesta(false);
            setalertaopcion("Error interno al grabar la encuesta");
            setstateModal(DataStateModal.dsClosed);
            setmodomodal(null);
        }   */         
    }

    const lanzarConfeti = (EsgameOver) => {
        let gameOver = EsgameOver != null ? EsgameOver : false; // Esta es la variable que determinar� el fin del juego

        const duration = gameOver ? 10 * 1000 : 2 * 1000;
        const animationEnd = Date.now() + duration;
        const defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 9999 };

        // Intervalo de confeti durante el tiempo determinado o indefinido
        const interval = setInterval(() => {
           
            const timeLeft = animationEnd - Date.now();

            // Si el tiempo ha pasado (para el caso no indefinido)
            if (timeLeft <= 0) {
                return clearInterval(interval);
            }

            const particleCount = 50 * (timeLeft / duration);
            confetti({
                ...defaults,
                particleCount,
                origin: {
                    x: Math.random(),
                    y: Math.random() - 0.2,
                },
            });
        }, 250);
    };

    const lanzarPapeles = () => {

        var end = Date.now() + (5 * 1000);

        // go Buckeyes!
        var colors = ['#bb0000', '#ffffff'];

        (function frame() {
            confetti({
                particleCount: 2,
                angle: 60,
                spread: 55,
                origin: { x: 0 },
                colors: colors
            });
            confetti({
                particleCount: 2,
                angle: 120,
                spread: 55,
                origin: { x: 1 },
                colors: colors
            });

            if (Date.now() < end) {
                requestAnimationFrame(frame);
            }
        }());
    }

    function renderModalValidacionLogin() {
        return (<OthelloModalBase titulo="Validacion Encuesta" modo={ModoModal.SinDefinir} open={stateModal} onCloseResulModal={othelloModalResul} >
            <OthelloPrimary><b>Debe logarse para poder empezar a jugar</b></OthelloPrimary>
            <form id="formvalidacion" >
                <Grid container>
                    <Grid item xs={12}>
                        <OthelloEdit label="Usuario o Email..." fieldname="email" />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={12}>
                        <OthelloEdit label="Password" type="password" fieldname="password" />
                    </Grid>
                </Grid>
                {guardandoencuesta ? <CircularProgress color="secondary" /> : ""}
                <Grid container xs={12}><Grid item xs={12} sm={4}><Link to="/authapps/register" >Registrate</Link> </Grid>
                    <Grid item xs={12} sm={8}><Link to="/authapps/rememberpass" >He olvidado mi contrase&ntilde;a</Link></Grid>
                </Grid>
            </form>
        </OthelloModalBase>);
    }

    function renderMostrarError(IdError)
    {       
        let tituloerror = "";
        let textoerror = "";

        if (IdError == TipoError.Preguntas) {

            tituloerror = t("_errorjuego")
            textoerror =  t("_errorjuegotexto")
        }
        else if (IdError == TipoError.ErrorCargaJuego) {
            tituloerror = t("_errorcargarjuego")
            textoerror = t("_errorcargarjuego")
        }
        else if (IdError == TipoError.JuegoNoDisponible) {
            tituloerror = t("_nodispojuego")
            textoerror = t("_nodispojuegotexto")
        }
                 
        return <MDBox
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            position="absolute" // o "fixed", seg�n tu layout
            top={0}
            left={0}
            width="100%"
            height="100%"
            bgcolor="rgba(255, 255, 255, 0.8)" // Fondo blanco semitransparente
            zIndex={9999} // Para asegurar que est� encima
            textAlign="center"
            px={3}
        >
            <Icon sx={{ fontSize: 60, color: "warning.main", mb: 2 }}>
                error_outline
            </Icon>
            <MDTypography variant="h4" fontWeight="medium" color="warning">
                {tituloerror}
            </MDTypography>
            <MDTypography variant="body1" mt={2} color="text.secondary">
                {textoerror}
            </MDTypography>
        </MDBox>

    }

    function renderMapaUbicacion(pistaActual) {
    return (
        <MDBox
            sx={{
                position: "relative",
                height: "calc(100svh)",
                width: "100%",
                backgroundColor: "#ffffff",
                borderRadius: "xl",
                overflow: "hidden",
            }}
        >
            {/* Bot�n FAB para volver */}
            <MDBox
                sx={{
                    position: "absolute",
                    bottom: 30,
                    left: 20,
                    zIndex: 10,
                }}
            >
                <MDButton
                    variant="contained"
                    color="info"
                    onClick={(e) => BotonMapa(e)}
                    sx={{
                        borderRadius: "50%",
                        minWidth: "48px",
                        height: "48px",
                        padding: 0,
                        boxShadow: 3,
                        transition: "all 0.2s ease-in-out",
                        "&:hover": {
                            transform: "scale(1.08)",
                            boxShadow: 6,
                        },
                    }}
                >
                    <Icon>arrow_back</Icon>
                </MDButton>
            </MDBox>

            {/* Bot�n FAB para abrir en Google Maps */}
            <MDBox
                sx={{
                    position: "absolute",
                    bottom: 30,
                    right: 70,
                    zIndex: 10,
                }}
            >
                <MDButton
                    variant="contained"
                    color="success"
                    onClick={() => {
                        const lat = pistaActual?.lat || 0;
                        const lon = pistaActual?.lon || 0;
                        const url = `https://www.google.com/maps/search/?api=1&query=${lat},${lon}`;
                        window.open(url, '_blank');
                    }}
                    sx={{
                        borderRadius: "50%",
                        minWidth: "48px",
                        height: "48px",
                        padding: 0,
                        boxShadow: 3,
                        transition: "all 0.2s ease-in-out",
                        "&:hover": {
                            transform: "scale(1.08)",
                            boxShadow: 6,
                        },
                    }}
                >
                    <Icon>place</Icon>
                </MDButton>
            </MDBox>

            {/* Contenedor del mapa */}
            <MDBox
                id="contactUsMap2"
                className="big-map"
                sx={{
                    height: "100%",
                    width: "100%",
                    backgroundColor: "#e0e0e0",
                }}
            >
                {GetGoogleMaps(
                    pistaActual?.lat || 0,
                    pistaActual?.lon || 0
                )}
            </MDBox>
        </MDBox>
    );
}
          
    function renderPantallaExplicacion(ModoPregunta, tituloShow, textoShow, textoBotonContinuar, findejuego) {
        return (
            <MDBox
                width="100%"
                minHeight="100svh"
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                sx={{
                    bgcolor: currentstep === -1 ? "rgba(18, 18, 18, 0.2)" : "rgba(18, 18, 18, 0.6)",
                    backdropFilter: currentstep === -1 ? "" : "blur(4px)",
                    px: 2
                }}
            >
                {/* Contenido principal con scroll */}
                <MDBox
                    p={3}
                    flexGrow={1}
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    textAlign="center"
                    sx={{
                        overflowY: "auto", // Permite el scroll vertical si el contenido es muy largo
                        maxHeight: "80vh", // Limita la altura m�xima para que no ocupe toda la pantalla
                        minHeight: 0, // Asegura que el contenedor ocupe el espacio disponible
                    }}
                >
                    {/* T�tulo */}
                    {tituloShow?.trim() !== "" && (
                        <Slide key={`${currentstep}-${tituloShow}`} bottom>
                            <MDTypography
                                fontWeight="700"
                                color="white"
                                gutterBottom
                                sx={{
                                    fontSize: { xs: '26px', sm: '30px', md: '36px' },
                                    letterSpacing: 1.2,
                                    textAlign: "center",
                                    px: 2
                                }}
                            >
                                {tituloShow}
                            </MDTypography>
                        </Slide>
                    )}
                    {findejuego && (
                        <MDBox mt={4} display="flex" justifyContent="center" alignItems="center">
                            <MDBox
                                px={4}
                                py={3}
                                mb={4}
                                bgcolor="linear-gradient(135deg, rgba(33, 150, 243, 1), rgba(0, 188, 212, 1))"
                                borderRadius="lg"
                                display="flex"
                                alignItems="center"
                                sx={{
                                    boxShadow: 12,
                                    transform: "scale(1)",
                                    transition: "all 0.4s ease-out",
                                    border: "2px solid #fff", // Borde blanco sutil
                                    '&:hover': {
                                        boxShadow: 20, // Aumento de sombra en hover
                                        transform: "scale(1.05)",
                                        bgcolor: "rgba(33, 150, 243, 1)",
                                        border: "2px solid rgba(0, 188, 212, 1)", // Borde de otro color en hover
                                    }
                                }}
                            >
                                {/* Avatar a la izquierda */}
                                <Avatar
                                    alt="Ayudante"
                                    src={getImageAvatar()}
                                    sx={{
                                        width: { xs: 55, sm: 70 },  // Reducimos el tama�o en pantallas peque�as
                                        height: { xs: 55, sm: 70 },
                                        border: '2px solid #fff',
                                        mr: 2,  // Espacio entre el avatar y la puntuaci�n
                                    }}
                                />
                                <Star sx={{ fontSize: 26, color: "#ffd700", mx: 0.5 }} />
                                {/* Puntuaci�n a la derecha */}
                                <MDTypography
                                    variant="h4" // T�tulo m�s grande
                                    color="white"
                                    fontWeight="bold"
                                    sx={{
                                        fontSize: { xs: '32px', sm: '40px', md: '50px' }, // Tama�os de fuente m�s grandes
                                        textAlign: "center",
                                        animation: "fadeIn 1s ease-in-out", // Animaci�n de fade-in
                                    }}
                                >
                                    {puntos} pts
                                </MDTypography>
                                
                            </MDBox>
                        </MDBox>

                    )}
                    {/* Texto descriptivo con HTML */}
                    <Fade key={`${currentstep}-${textoShow}`} delay={300}>
                        <MDTypography
                            fontWeight="300"
                            color="white"
                            mt={0}
                            mb={1}
                            sx={{
                                fontSize: { xs: '16px', sm: '18px', md: '20px' },
                                maxWidth: "700px",
                                lineHeight: 1.8,
                                textAlign: "center",
                                px: 2
                            }}
                            dangerouslySetInnerHTML={{ __html: textoShow }}
                        />
                    </Fade>
                    {/* Bot�n de mapa (modo pista) */}
                    {ModoPregunta && (
                        <MDBox mt={4} display="flex" justifyContent="center">
                            <Zoom>
                                <MDBox
                                    onClick={(e) => BotonMapa(e)}
                                    sx={{
                                        width: 90,
                                        height: 90,
                                        borderRadius: "16px",
                                        backgroundColor: "rgba(33, 150, 243, 0.8)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: 6,
                                        cursor: "pointer",
                                        transition: "all 0.3s ease",
                                        '&:hover': {
                                            transform: "scale(1.05)",
                                            boxShadow: 10,
                                            backgroundColor: "rgba(33, 150, 243, 1)",
                                        }                                        
                                    }}
                                >
                                    <Map sx={{ fontSize: 40, color: "#fff" }} />
                                </MDBox>
                            </Zoom>
                        </MDBox>
                    )}
                </MDBox>

                {/* Bot�n de continuar */}
                <MDBox p={3} display="flex" justifyContent="center" mb={4}>
                    <MDButton
                        variant="contained"
                        color="info"
                        size="large"
                        circular
                        sx={{
                            borderRadius: "2xl",
                            boxShadow: 4,
                            px: { xs: 6, sm: 12, md: 20 },
                            py: 1.5,
                            textTransform: "none",
                            fontWeight: "bold",
                            fontSize: { xs: '16px', sm: '18px', md: '20px' },                                                        
                        }}
                        onClick={(e) => ModoPregunta ? NextStepEnPregunta(e) : NextStep(e)}
                    >
                        {textoBotonContinuar}
                    </MDButton>
                </MDBox>
            </MDBox>
        );
    }

    function renderFinJuego(TipoScreenShow) {

        let encuestafinalizada = TipoScreenShow == TipoPantalla.EncuestaFinalizada

        if (encuestafinalizada)
        {           
            return <MDBox
                sx={{
                    height: "100svh", // Ocupa todo el alto de la ventana
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    background: "linear-gradient(135deg, #1f1c2c, #928dab)", // Fondo moderno con transici�n suave
                    color: "white",
                    px: 3,
                    py: 4,
                    textAlign: "center",
                }}
            >
                {/* Mensaje central */}
                <MDBox maxWidth="600px">
                    <MDTypography
                        variant="h2"
                        fontWeight="bold"
                        gutterBottom
                        sx={{
                            color: "#fff",
                            textShadow: "2px 2px 10px rgba(0,0,0,0.8)",
                            letterSpacing: 1,
                            mb: 2,
                        }}
                    >
                        {t("_graciasporjugar")}
                    </MDTypography>
                    <MDTypography variant="h6" fontWeight="300" color="white" mt={2} sx={{ opacity: 0.9 }}>
                        {t("_nosayuda")}
                        <br />
                        {t("_dejacomentario")}
                    </MDTypography>
                </MDBox>

                {/* Bot�n de reinicio */}
                <MDBox width="100%" maxWidth="320px" mt={6}>
                    <MDButton
                        variant="gradient"
                        color="info"
                        size="large"
                        fullWidth
                        sx={{
                            fontWeight: 'bold',
                            fontSize: '1.1rem',
                            borderRadius: '12px',
                            py: 1.5,
                            background: "linear-gradient(90deg, #1CB5E0, #000851)", // Azul moderno
                            boxShadow: '0 4px 14px rgba(0, 0, 0, 0.4)',
                            "&:hover": {
                                background: "linear-gradient(90deg, #000851, #1CB5E0)",
                            },
                        }}
                        onClick={(e) => ReiniciarJuego(e, true)}
                    >
                        {t("_volverajugar")}
                    </MDButton>

                </MDBox>
            </MDBox>


        }
        else
            return renderPantallaExplicacion(false, encuesta.tituloFinEncuesta, encuesta.textoFinEncuesta, "Continuar", true);
    }
    
    function renderRealizarPreguntaZonaCabecero(PasoPregunta) {
        const esModoInfo = PasoPregunta !== PasosPregunta.RealizaPregunta;
        const indexPregunta = getCurrentIndexPregunta();

        return (
            <MDBox
                width="100%"
                sx={{
                    backgroundColor: "rgba(0, 30, 60, 0.5)",
                    backdropFilter: "blur(6px)",
                    borderBottom: "1px solid rgba(255, 255, 255, 0.1)"
                }}
            >
                {/* Fila superior de botones */}
                <MDBox
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                    px={2}
                    py={1.25}
                >
                    <Tooltip title="Reiniciar Juego">
                        <IconButton
                            sx={{ color: "#fff", width: 48, height: 48 }}
                            onClick={(e) => ReiniciarJuego(e, false)}
                        >
                            <HomeIcon sx={{ fontSize: 30 }} />
                        </IconButton>
                    </Tooltip>

                    <Stack direction="row" spacing={1}>
                        <Tooltip title="Mapa">
                            <span>
                                <IconButton
                                    sx={{
                                        color: !esModoInfo ? "#90caf9" : "rgba(255,255,255,0.3)",
                                        width: 48,
                                        height: 48,
                                        transition: "0.3s",
                                        "&:hover": {
                                            color: !esModoInfo ? "#ffffff" : "inherit"
                                        }
                                    }}
                                    onClick={!esModoInfo ? BotonMapa : undefined}
                                    disabled={esModoInfo}
                                >
                                    <Map sx={{ fontSize: 30 }} />
                                </IconButton>
                            </span>
                        </Tooltip>

                        <Tooltip title="Pistas">
                            <span>
                                <IconButton
                                    sx={{
                                        color: !esModoInfo ? "#ffca28" : "rgba(255,255,255,0.3)",
                                        width: 48,
                                        height: 48,
                                        transition: "0.3s",
                                        "&:hover": {
                                            color: !esModoInfo ? "#ffffff" : "inherit"
                                        }
                                    }}
                                    onClick={!esModoInfo ? BotonPistas : undefined}
                                    disabled={esModoInfo}
                                >
                                    <TipsAndUpdatesIcon sx={{ fontSize: 30 }} />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Stack>
                </MDBox>

                {/* Separador moderno */}
                <MDBox
                    sx={{
                        width: "100%",
                        height: 1.5,
                        background: "linear-gradient(to right, rgba(255, 255, 255, 0.1), rgba(255, 255, 255, 0.2))",
                        boxShadow: "0 1px 3px rgba(0, 0, 0, 0.6)"
                    }}
                />

                {/* L�nea de progreso + puntos */}
                <MDBox
                    width="100%"
                    px={2}
                    pb={1.25}
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                >
                    {/* Texto y barra */}
                    <MDBox flex={1} mr={2}>
                        <MDTypography
                            variant="caption"
                            color="white"
                            fontWeight="500"
                            sx={{ mb: 0.25, fontSize: { xs: "12px", sm: "13px" } }}
                        >
                            Pregunta {indexPregunta + 1} de {encuesta.preguntas.length}
                        </MDTypography>

                        <LinearProgress
                            variant="determinate"
                            value={((indexPregunta + 1) / encuesta.preguntas.length) * 100}
                            sx={{
                                height: 6,
                                borderRadius: 50,
                                backgroundColor: "rgba(255,255,255,0.2)",
                                "& .MuiLinearProgress-bar": {
                                    backgroundColor: "#2196f3"
                                }
                            }}
                        />
                    </MDBox>

                    {/* Puntos usuario */}
                    <MDBox
                        px={1.5}
                        pt={1.5}
                        bgcolor="rgba(255, 255, 255, 0.1)"
                        borderRadius="lg"
                        display="flex"
                        alignItems="center"
                    >
                        <Star sx={{ fontSize: 19, color: "#ffd700", mr: 0.5 }} />
                        <MDTypography variant="caption" color="white" fontWeight="bold">
                            {puntos} pts
                        </MDTypography>
                    </MDBox>
                </MDBox>
            </MDBox>
        );
    }

    function renderRealizarPreguntaZonaPista(pistaActual) {
        const opciones = pistaActual.opciones?.split("|") || [];
       
        return (
            <Grid container>
                <Grid item xs={12}>
                    <MDBox
                        mt={1}
                        mx={1}
                        px={2}
                        py={1}
                        sx={{
                            backgroundColor: pistasopen ? "#fff9e6" : "rgba(18, 18, 18, 0.45)",
                            borderRadius: 3,
                            boxShadow: pistasopen ? 1 : 5,
                            backdropFilter: pistasopen ? "none" : "blur(6px)",
                            border: pistasopen ? "1px solid #fcd34d" : "1px solid rgba(255,255,255,0.08)",
                            transition: "all 0.3s ease-in-out",
                            overflow: "hidden",
                            position: "relative",
                        }}
                        onClick={(e) => !pistasopen ? handleSpeak(e, pistaActual?.descripcion) : null}
                    >
                        {/* Bot�n de cerrar pistas */}
                        {pistasopen && (
                            <MDBox position="absolute" top={8} right={8} zIndex={10}>
                                <Tooltip title={t("_cerrar")}>
                                    <IconButton
                                        onClick={(e) => BotonPistas(e)}
                                        sx={{
                                            backgroundColor: "rgba(0,0,0,0.05)",
                                            color: "#000",
                                            "&:hover": {
                                                backgroundColor: "rgba(0,0,0,0.15)",
                                            },
                                            width: 32,
                                            height: 32,
                                        }}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                </Tooltip>
                            </MDBox>
                        )}

                        {/* Header */}
                        <MDBox display="flex" alignItems="center" mb={1}>
                            <MDAvatar
                                size="md"
                                variant="rounded"
                                sx={{
                                    backgroundColor: pistasopen ? "#fbc000" : "#2196f3",
                                    p: 1,
                                    mr: 1,
                                    borderRadius: "xl",
                                    boxShadow: 2,
                                }}
                            >
                                {pistasopen ? (
                                    <TipsAndUpdates fontSize="medium" />
                                ) : (
                                    <AutoStories fontSize="medium" sx={{ color: "#fff" }} />
                                )}
                                {!pistasopen ? <VolumeUpIcon
                                    sx={{
                                        fontSize: "12px",
                                        color: "#fff",
                                        position: "absolute",
                                        bottom: 2,
                                        right: 2,
                                        opacity: 0.8,
                                        cursor: "pointer",
                                    }}
                                /> : ""}
                            </MDAvatar>
                            <MDTypography
                                variant="h5"
                                fontWeight="bold"
                                color={pistasopen ? "dark" : "white"}
                                fontSize={{ xs: "1.1rem", sm: "1.2rem" }}
                            >
                                {pistasopen ? t("_pistas") : t("_informacion")}
                            </MDTypography>
                        </MDBox>

                        {/* Contenido */}
                        <MDBox textAlign="center" sx={{ minHeight: 100 }}>
                            {pistasopen ? (
                                <Slide bottom cascade>
                                    <div>
                                        {opciones.length > 0 ? (
                                            opciones.map((textoPista, index) => {
                                                const mostrar = pistashowed >= index;
                                                const esUltima = pistashowed === opciones.length - 2;
                                                const textoBoton = esUltima ? "Ver respuesta" : "Siguiente pista";

                                                return (
                                                    mostrar && (
                                                        <MDBox key={index} mb={1}>
                                                            <MDTypography
                                                                variant="body1"
                                                                fontWeight="400"
                                                                color="text"
                                                                fontSize={{ xs: 15, sm: 16 }}
                                                                mb={0.5}
                                                                sx={{ wordBreak: "break-word" }}
                                                            >
                                                                {textoPista}
                                                            </MDTypography>

                                                            {pistashowed === index &&
                                                                pistashowed < opciones.length - 1 ? (
                                                                <MDButton
                                                                    variant="outlined"
                                                                    color="warning"
                                                                    size="small"
                                                                    onClick={(e) => NextPistas(e)}
                                                                    sx={{
                                                                        fontSize: 12,
                                                                        py: 0.5,
                                                                        px: 1.5,
                                                                        textTransform: "none",
                                                                    }}
                                                                >
                                                                    {textoBoton}
                                                                </MDButton>
                                                            ) : (
                                                                <Divider sx={{ my: 0.5 }} />
                                                            )}
                                                        </MDBox>
                                                    )
                                                );
                                            })
                                        ) : (
                                            <MDTypography
                                                variant="body1"
                                                fontWeight="400"
                                                color="text"
                                                fontSize={14}
                                                mb={0.5}
                                            >
                                                {t("_nohaypistas")}
                                            </MDTypography>
                                        )}
                                    </div>
                                </Slide>
                            ) : (
                                <Fade cascade>
                                    <MDTypography
                                        variant="body1"
                                        color="white"
                                        fontWeight="300"
                                        lineHeight={1.6}
                                        fontSize={{ xs: 13, sm: 14 }}
                                        sx={{
                                            whiteSpace: "pre-line",
                                            textAlign: "left",
                                            wordBreak: "break-word",
                                        }}
                                    >
                                        {!descripcionMostrada ? (
                                            <TypingEffect
                                                text={[pistaActual?.descripcion || "..."]}
                                                speed={50}
                                                typingDelay={500}
                                                eraseDelay={100000}
                                                cursor="|"
                                                cursorColor="black"
                                                onTypingDone={() => setDescripcionMostrada(true)}
                                            />
                                        ) : (
                                            pistaActual?.descripcion || "..."
                                        )}
                                    </MDTypography>
                                </Fade>
                            )}
                        </MDBox>
                    </MDBox>
                </Grid>
            </Grid>
        );
    }

    function renderRealizarPreguntarZonaAyudante(pistaActual) {
        let mensaje = getDataAsistenteVirtual(pistaActual);

        return (
            <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                    width: "100%",
                    minHeight: "15vh", // Reducimos la altura m�nima para que ocupe menos espacio
                    mt: 1,  // Reducimos el margen superior
                    px: 2,  // Mantener padding horizontal reducido
                }}
            >
                <MDBox
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    flexDirection="column"
                    sx={{
                        width: "100%",
                        maxWidth: 320, // Un poco m�s estrecho
                        padding: 1,  // Reducimos el padding
                        backgroundColor: "#444",
                        borderRadius: 3,
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
                        zIndex: 2,
                    }}
                >                    
                    <MDBox
                        display="flex"
                        alignItems="center"
                        gap={1}  // Reducimos el espacio entre los elementos
                        sx={{
                            backgroundColor: 'rgba(255, 255, 255, 0.05)',
                            borderRadius: 2,
                            p: 1,  // Reducimos el padding del contenedor del avatar
                            width: "100%",
                            flexWrap: "wrap",
                        }}
                    >
                        <Avatar
                            alt="Ayudante"
                            src={getImageAvatar()}
                            sx={{
                                width: { xs: 55, sm: 70 },  // Reducimos el tama�o en pantallas peque�as
                                height: { xs: 55, sm: 70 },
                                border: '2px solid #fff',
                            }}
                            onClick={(e) => handleSpeak(e, mensaje)}
                        />                           
                        <MDBox
                            display="flex"
                            flexDirection="column"
                            flex="1"
                            minWidth={0}
                        >                            
                            {/*textoasistente !== TextoAsistente.Bienvenido && (
                                <MDBox display="flex" alignItems="center" gap={1}>
                                    <EmojiEventsIcon
                                        sx={{
                                            fontSize: 25,  // Reducimos el tama�o del icono
                                            color: '#FFD700',
                                        }}
                                    />
                                    <MDTypography
                                        variant="body1"
                                        sx={{
                                            color: '#FFD700',
                                            fontWeight: 'bold',
                                            fontSize: { xs: 15, sm: 16 },  // Reducimos el tama�o de la fuente
                                            lineHeight: 1,
                                        }}
                                    >
                                        {t("_puntos")}: {puntos}
                                    </MDTypography>
                                </MDBox>
                            )*/}
                            <MDTypography
                                variant="body2"
                                color="white"
                                fontWeight="normal"
                                sx={{
                                    mt: 1,
                                    fontSize: { xs: 14, sm: 16 },  // Ajustamos el tama�o de la fuente para pantallas peque�as
                                    lineHeight: 1.4,  // Ajustamos el interlineado para mayor compresi�n
                                    whiteSpace: "pre-line",
                                }}
                            >
                                {mensaje}
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                </MDBox>
            </MDBox>
        );
    }

    function renderRealizarPreguntaZonaContestar(pistaActual) {
        const handleInputFocus = () => {
            // Desplazar el campo de entrada a la vista cuando se enfoque
            const inputElement = document.getElementById("respuesta");
            if (inputElement) {
                inputElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        };

        return (
            <MDBox
                mt={2}
                mx={1}
                px={2}
                py={2}
                mb={1.5}
                sx={{
                    backgroundColor: "rgba(255, 255, 255, 0.95)",
                    borderRadius: 3,
                    boxShadow: 4,
                    border: "1px solid rgba(0,0,0,0.1)",
                    overflowY: 'auto', // Permitir desplazamiento en la zona de contenido
                    maxHeight: 'calc(100vh - 150px)', // Ajuste para evitar el corte de contenido
                }}
            >
                {/* Header */}
                <MDBox display="flex" alignItems="center" mb={1} onClick={ (e) => handleSpeak(e, pistaActual.pregunta) }>
                    <MDAvatar
                        size="sm"
                        variant="rounded"
                        sx={{
                            backgroundColor: "info.main",
                            p: 1,
                            mr: 1.5,
                            borderRadius: "xl",
                            width: 36,
                            height: 36,
                            boxShadow: 2
                        }}
                    >
                        <QuestionAnswer fontSize="small" sx={{ color: "#fff" }} />
                        <VolumeUpIcon
                            sx={{
                                fontSize: "6px",
                                color: "#fff",
                                position: "absolute",
                                bottom: 2,
                                right: 2,
                                opacity: 0.8,
                                cursor: "pointer",
                            }}
                        />
                    </MDAvatar>
                    <MDTypography
                        variant="subtitle1"
                        fontWeight="bold"
                        color="dark"
                        fontSize={15}
                    >
                        {t("_adivina")}
                    </MDTypography>
                </MDBox>

                {/* Pregunta */}
                <MDTypography
                    variant="body2"
                    fontWeight="400"
                    color="text.primary"
                    lineHeight={1.6}
                    fontSize={14}
                    mb={1.5}
                >
                    {pistaActual.pregunta}
                </MDTypography>

                {/* Input + Bot�n */}
                <MDBox display="flex" alignItems="center" gap={1}>
                    <MDInput
                        id="respuesta"
                        name="respuesta"
                        placeholder="Respuesta..."
                        fullWidth
                        sx={{
                            "& .MuiInputBase-root": {
                                borderRadius: "10px",
                                backgroundColor: "#f0f4f8",
                                fontSize: 14,
                                height: 42,
                                paddingLeft: 2,
                                paddingRight: 2
                            },
                            "& input": {
                                padding: "10px 0"
                            }
                        }}
                        onFocus={handleInputFocus} // Llamar a la funci�n al enfocar el input
                    />
                    <MDButton
                        variant="gradient"
                        color="info"
                        onClick={(e) => ResponderPregunta(e)}
                        disabled={esperandoProximaPregunta}
                        sx={{
                            minWidth: 42,
                            height: 42,
                            borderRadius: "10px",
                            padding: 0,
                            minHeight: "42px"
                        }}
                    >
                        <Icon fontSize="small">send</Icon>
                    </MDButton>
                </MDBox>
            </MDBox>
        );
    }
    
    function renderPreguntaResultado(pistaActual) {
        return (
            <MDBox height="100%" display="flex" flexDirection="column">
                <MDBox
                    mx={2}
                    mr={2}
                    mt={0}
                    px={3}
                    py={3}
                    sx={{
                        backgroundColor: "rgba(255, 255, 255, 0.95)",
                        borderRadius: 4,
                        boxShadow: 6,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        height: "100%",
                        overflowY: "auto",
                        maxHeight: "75vh",
                    }}
                >
                    {/* Contenido superior */}
                    <MDBox>
                        {/* Header */}
                        <MDBox display="flex" alignItems="center" mb={3}
                            onClick={(e) => handleSpeak(e, pistaActual.infoAdicional)}
                        >                            
                            <Pulse forever duration={1500}>
                                <MDAvatar
                                    size="md"
                                    variant="rounded"
                                    sx={{
                                        backgroundColor: "success.main",
                                        p: 1,
                                        mr: 2,
                                        borderRadius: "xl",
                                        boxShadow: 3,
                                    }}
                                >
                                    <CheckCircleOutline fontSize="small" sx={{ color: "#fff" }} />
                                    <VolumeUpIcon
                                        sx={{
                                            fontSize: "12px",
                                            color: "#fff",
                                            position: "absolute",
                                            bottom: 2,
                                            right: 2,
                                            opacity: 0.8,
                                            cursor: "pointer",
                                        }}
                                    />
                                </MDAvatar>                              
                            </Pulse>
                            <MDBox display="flex" flexDirection="column" alignItems="center" ml={2}>
                                <MDTypography
                                    variant="h4"
                                    fontWeight="bold"
                                    color="success.main"
                                    textAlign="center"
                                    sx={{
                                        fontSize: { xs: "18px", sm: "22px", md: "24px" },
                                    }}
                                >
                                    <span style={{ fontWeight: 700 }}>{t("_respuestacorrecta")}</span>
                                </MDTypography>
                            </MDBox>
                        </MDBox>

                        {/* Resultado adivinanza */}
                        <MDTypography
                            variant="h3"
                            fontWeight="bold"
                            color="info.main"
                            textAlign="center"
                            mb={2}
                            sx={{
                                backgroundColor: "rgba(200, 200, 200, 0.5)",
                                borderRadius: "2px",
                                padding: "6px",
                                backdropFilter: "blur(8px)",
                                color: "white",
                                fontSize: { xs: "20px", sm: "24px", md: "28px" },
                                maxWidth: { xs: "85%", sm: "80%", md: "70%" },
                                mx: "auto",
                            }}
                        >
                            {pistaActual.defaultValue}
                        </MDTypography>

                        {/* Texto explicativo */}
                        <MDTypography
                            variant="body2"
                            fontWeight="regular"
                            color="text.primary"
                            lineHeight={1.5}
                            mb={3}
                            textAlign="center"
                            sx={{
                                fontSize: { xs: "14px", sm: "16px", md: "18px" },
                                maxWidth: "80%",
                                mx: "auto",
                            }}
                            dangerouslySetInnerHTML={{ __html: pistaActual.infoAdicional }}
                        />

                        {/* Imagen */}
                        {pistaActual.image && (
                            <MDBox display="flex" justifyContent="center" mt={3} width="100%" bgColor="transparent">
                                <MDBox
                                    component="img"
                                    src={pistaActual.image}
                                    alt="Imagen de pista"
                                    sx={{
                                        maxWidth: "80%",
                                        maxHeight: { xs: 200, sm: 250, md: 400},
                                        objectFit: "contain",
                                        borderRadius: 2,
                                        boxShadow: 3,
                                        backgroundColor: "transparent",
                                    }}
                                />
                            </MDBox>
                        )}
                    </MDBox>

                    {/* Bot�n de continuar */}
                    <MDBox pt={4}
                        sx={{
                            paddingBottom: "calc(32px + env(safe-area-inset-bottom, 0px))",                            
                        }}
                    >
                        <MDButton
                            variant="gradient"
                            color="info"
                            size="large"
                            fullWidth
                            onClick={(e) => NextStepEnPregunta(e)}
                            sx={{
                                borderRadius: "xl",
                                boxShadow: 3,
                                fontWeight: "bold",
                                py: 1.5,
                                fontSize: { xs: "16px", sm: "18px", md: "20px" },
                            }}
                        >
                            {t("_continuar")}
                        </MDButton>
                    </MDBox>
                </MDBox>
            </MDBox>
        );
    }

    function renderPreguntasJuego()
    {
        let PreguntaActual = getPreguntaActual();

        //SI tenemos una pregunta a mostrar
        if (PreguntaActual != null)
        {
            let Paso = getPasoEnPregunta();

            return <MDBox
                width="100%"
                display="flex"
                flexDirection="column"
                justifyContent="space-between"
                sx={{
                    minHeight: "100svh",
                    //En modo info pregunta, no lo pongo porque ya lo hace el renderPantallaExplicacion
                    bgcolor: Paso == PasosPregunta.InfoPregunta ? "" : "rgba(18, 18, 18, 0.6)", // Fondo m�s transl�cido en tonos oscuros
                    backdropFilter: Paso != PasosPregunta.InfoPregunta ? "" : "blur(4px)"       // Efecto de desenfoque para fondo                   
                }}
            >
                {/* Contenido superior: cabecera y preguntas/pistas */}
                <MDBox width="100%" flex="1" display="flex" flexDirection="column" gap={2}>
                    {/* Oculto el cabecero en el caso de que estemos en una informacion inicial de la pregunta   */}
                    {Paso != PasosPregunta.InfoPregunta ? renderRealizarPreguntaZonaCabecero(Paso) : ""}
                    <MDBox>
                        {mapaopen ? renderMapaUbicacion(PreguntaActual) : ""}
                        {!mapaopen && Paso == PasosPregunta.InfoPregunta ? renderPantallaExplicacion(true, "", PreguntaActual.infoInicial, "Continuar") : ""}
                        {!mapaopen && Paso == PasosPregunta.RealizaPregunta ? renderRealizarPreguntaZonaPista(PreguntaActual) : ""}
                        {!mapaopen && Paso == PasosPregunta.RealizaPregunta ? renderRealizarPreguntarZonaAyudante(PreguntaActual) : ""}
                        {!mapaopen && Paso == PasosPregunta.ResultadoPregunta ? renderPreguntaResultado(PreguntaActual) : ""}
                    </MDBox>
                </MDBox>
                {/* Zona para responder preguntas */}
                <MDBox mt={3}>
                    {!mapaopen && Paso == PasosPregunta.RealizaPregunta ? renderRealizarPreguntaZonaContestar(PreguntaActual) : ""}
                </MDBox>
            </MDBox>
        }
        else
            return renderMostrarError(TipoError.Preguntas);
    }

    function renderInicioJuego() {

        let tituloShow = "";
        let textoShow = "";
        let textoBoton = currentstep == -1 ? t("_jugar") : t("_continuar");

        if (currentstep == -1) {
            textoShow = "";
        }
        else if (currentstep == 0) {
            tituloShow = t("_introduccion");
            textoShow = encuesta.infoInicial;
        }
        else if (currentstep == 1) {
            textoShow = encuesta.descripcion;
        }
        else if (currentstep == 2) {
            textoShow = encuesta.infoAdicional;
        }
        else if (currentstep == 3) {
            tituloShow = t("_normas");

            if (encuesta.normasEncuesta != null && encuesta.normasEncuesta != "")
                textoShow = encuesta.normasEncuesta;
            else
                textoShow = t("_normastexto");
        }

        return renderPantallaExplicacion(false, tituloShow, textoShow, textoBoton, false);
    }

    function renderJuego()
    {        
        if (loading) {
            return <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                    minHeight: 140,
                    backgroundColor: "rgba(0, 0, 0, 0.6)",  // Fondo oscuro semi-transparente
                    borderRadius: 2,
                    padding: {
                        xs: "20px",  // Para dispositivos peque�os (m�viles)
                        sm: "20px 40px",  // Para pantallas m�s grandes
                    },
                    boxShadow: 2,
                    width: "100%", // Asegura que ocupe todo el ancho disponible
                    position: "absolute", // Lo coloca sobre la imagen de fondo
                    top: "50%", // Centrado verticalmente
                    left: "50%",
                    transform: "translate(-50%, -50%)", // Ajusta el centro
                }}
            >
                <CircularProgress color="secondary" size={50} sx={{ marginRight: 2 }} />
                <MDTypography variant="body1" color="white" fontWeight="400">
                    Cargando...
                </MDTypography>
            </MDBox>
        }
        else {
            if (encuesta != null && encuesta.id_Encuesta > 0)
            {
                if (encuesta.visible == Visibilidad.Si)
                {
                    //Obtengo que pantalla debo mostrar
                    let TipoScreenShow = getTipoPantallaToShow();

                    //Si estamos en un paso de mostrar informacion
                    if (TipoScreenShow == TipoPantalla.Informacion)
                        return renderInicioJuego();
                    else if (TipoScreenShow == TipoPantalla.Preguntas)
                        return renderPreguntasJuego();
                    else if (TipoScreenShow == TipoPantalla.FinJuego || TipoScreenShow == TipoPantalla.EncuestaFinalizada)
                        return renderFinJuego(TipoScreenShow);
                    else
                        return "FIN";
                } else 
                    return renderMostrarError(TipoError.JuegoNoDisponible);                                  
            }
            else
                return renderMostrarError(TipoError.ErrorCargaJuego);               
        }
    }

    function renderModanInformacion() {
        
        return <Dialog
            open={stateModalReiniciar}
            onClose={() => setstateModalReiniciar(false)}
            sx={{
                "& .MuiDialog-paper": {
                    borderRadius: 4,
                    padding: 3,
                    backgroundColor: "#ffffff",
                    boxShadow: 24,
                },
            }}
        >
            <MDBox display="flex" flexDirection="column" alignItems="center" textAlign="center">
                <MDAvatar
                    variant="rounded"
                    size="lg"
                    sx={{ bgcolor: "warning.main", mb: 2 }}
                >
                    <Icon fontSize="large">restart_alt</Icon>
                </MDAvatar>

                <MDTypography variant="h5" fontWeight="medium" color="text.primary">
                    {t("_surejuego")}
                </MDTypography>
                <MDTypography variant="body1" color="text.secondary" mt={1}>
                    {t("_reiniciarjuego")} 
                </MDTypography>

                <MDBox display="flex" justifyContent="center" gap={2} mt={4} width="100%">
                    <MDButton
                        variant="outlined"
                        color="secondary"
                        onClick={() => setstateModalReiniciar(false)}
                    >
                        {t("_cancelar")}
                    </MDButton>                    
                    <MDButton
                        variant="gradient"
                        color="error"
                        onClick={(e) => {
                            setstateModalReiniciar(false);
                            ReiniciarJuego(e, true)                            
                        }}
                    >
                        {t("_reiniciar")} 
                    </MDButton>
                </MDBox>
            </MDBox>
        </Dialog>
    }

    function renderModalRepuestaIncorrecta() {
        
        return <Dialog
            open={stateModalIncorrecta}
            onClose={() => setstateModalIncorrecta(false)}
            sx={{
                "& .MuiDialog-paper": {
                    borderRadius: 4,
                    padding: 3,
                    backgroundColor: "#ffffff",
                    boxShadow: 24,
                },
            }}
        >
            <MDBox display="flex" flexDirection="column" alignItems="center" textAlign="center">
                <MDAvatar
                    variant="rounded"
                    size="lg"
                    sx={{ bgcolor: "error.main", mb: 2 }}
                >
                    <ErrorOutlineIcon fontSize="large" />
                </MDAvatar>
                <MDTypography variant="h5" fontWeight="medium" color="error.main">
                    Respuesta incorrecta
                </MDTypography>
                <MDTypography variant="body1" color="text.secondary" mt={1}>
                    {t("_malasuerte")}
                </MDTypography>
                <MDTypography variant="body2" color="text.secondary" mt={1}>
                    {t("_intentagain")}
                </MDTypography>
                <MDBox display="flex" justifyContent="center" mt={4}>
                    <MDButton
                        variant="gradient"
                        color="primary"
                        onClick={() => setstateModalIncorrecta(false)}
                    >
                        {t("_volverintentar")}
                    </MDButton>
                </MDBox>
            </MDBox>
        </Dialog>

    }

    let alertafinal = alert != null ? <OthelloPopUpResult titulo={alertaopcion} alert={alert} onClosePopUpResult={onClosePopUpResult} /> : "";

    let modal = "";

    if (stateModal != DataStateModal.dsClosed && modomodal == "login")
        modal = renderModalValidacionLogin();

    let modalReinicia = renderModanInformacion();
    let modalErrorRespuesta = renderModalRepuestaIncorrecta();
   
    let imageniniciojuego = encuesta != null && encuesta.image != null && encuesta.image != "" ? encuesta.image : null;   
    
    return (
        <MDBox
            sx={{
                position: "relative",
                height: "100vh", // Usamos 100vh aqu� tambi�n
                width: "100%",
                backgroundImage: `url(${imageniniciojuego})`,
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                overflow: "hidden",
                paddingBottom: "env(safe-area-inset-bottom)",
            }}           
        >
            <Helmet>
                <title>{!loading ? encuesta.nombre : "Disfruta del Juego"}</title>
                <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover" />
            </Helmet>            
            <MDBox sx={{ position: "relative", zIndex: 2, height: "100%", overflow: "hidden" }}>
                {alertafinal}
                {modal}
                {modalReinicia}
                {modalErrorRespuesta}
                {renderJuego()}
            </MDBox>
        </MDBox>
    );


}
